export default __webpack_public_path__ + "static/image5-e0e2bdddd3a51cefe86586c4e762ca59.jpeg";